import { createApi } from '@reduxjs/toolkit/query/react';
import { apiSahClientHcpUnspentFunds } from 'tsx/constants/api';

import { Request, rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { ClientHcpUnspentFunds } from '~support-at-home/models';

export const typePrefix = 'hcp-unspent-funds';

export const clientHcpUnspentFundsApi = createApi({
  reducerPath: 'clientHcpUnspentFundsApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiSahClientHcpUnspentFunds }),
  tagTypes: ['clientHcpUnspentFunds'],
  endpoints: (builder) => ({
    getClientHcpUnspentFunds: builder.query<ClientHcpUnspentFunds[], Request>({
      query: (params) => ({ url: '', method: 'GET', params }),
      providesTags: [{ type: 'clientHcpUnspentFunds', id: 'LIST' }],
      transformResponse: (payload) => unwrap<ClientHcpUnspentFunds[]>(payload),
    }),
  }),
});

export const { useGetClientHcpUnspentFundsQuery, useLazyGetClientHcpUnspentFundsQuery } = clientHcpUnspentFundsApi;
